import { render, staticRenderFns } from "./StatisticsAbout.vue?vue&type=template&id=3e181d7a&scoped=true&"
import script from "./StatisticsAbout.vue?vue&type=script&lang=js&"
export * from "./StatisticsAbout.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsAbout.vue?vue&type=style&index=0&id=3e181d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e181d7a",
  null
  
)

export default component.exports